<template>
	<div class="circle-number" :style="cssVariables">
		<div class="circle-number__number">{{ value }}</div>
	</div>
</template>

<script>
	export default {
		name: 'CircleNumber',

		props: {
			color: {
				default: '#fff',
			},
			value: {
				default: 1,
			},
		},

		data () {
			return {
			};
		},

		computed: {
			cssVariables() {
				return {
					'--color': this.color,
				};
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import '@/styles/variables';
	@import '@/styles/mixins';

	$color: var(--color);

	.circle-number {
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		width: 40px;
		min-width: 40px;
		font-size: 20px;
		border: 2px solid $color;
		color: $color;
	}
</style>
